import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApprenantsComponent } from './components/apprenants/apprenants.component';
import { ProfilComponent } from './components/profil/profil.component';
import { CreateUserComponent } from './components/create-user/create-user.component';
import { ListeUserComponent } from './components/liste-user/liste-user.component';
import { SIGUIAppelsComponent } from '../appels/components/sigui-appels/sigui-appels.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { StatisticsGlobalComponent } from './components/statistics-global/statistics-global.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { ListMentorsComponent } from '../mentorat/components/list-mentors/list-mentors.component';
import { ListDossierByCandidatMentoratComponent } from '../mentorat/components/list-dossier-by-candidat-mentorat/list-dossier-by-candidat-mentorat.component';
import { ApprenantbeninComponent } from './components/apprenantbenin/apprenantbenin.component';

const routes: Routes = [
  {
    path: '',
    component: ApprenantsComponent,
  },
  {
    path: 'profil',
    component: ProfilComponent,
  },
  {
    path: 'createUser',
    component: CreateUserComponent,
  },
  {
    path: 'list',
    component: ListeUserComponent,
  },
  {
    path: 'apprenants',
    component: ApprenantsComponent,
  },
  {
    path: 'mesapprenants',
    component: ApprenantbeninComponent,
  },
  {
    path: 'list-mentors',
    component: ListMentorsComponent,
  },
  {
    path: 'mentors/candidats/dossiers',
    component: ListDossierByCandidatMentoratComponent,
  },
  {
    path: 'appel-SIGUI',
    component: SIGUIAppelsComponent,
  },
  {
    path: 'statistics',
    component: StatisticsComponent,
  },
  {
    path: 'statistics-global',
    component: StatisticsGlobalComponent,
  },
  {
    path: 'apprenants',
    component: ApprenantsComponent,
  },
  {
    path: 'portfolio',
    component: PortfolioComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UtilisateursRoutingModule { }
